import { useMutation } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { handleDefaultMarketplace } from "../../../utils/handleDefaultMarketplace";
import { isNetworkError } from "../../../utils/isNetworkError";
import { errorToast } from "../../../utils/toasts";

export const useSetOrgId = () => {
  const { t } = useTranslation(["common"]);

  return useMutation({
    mutationFn: async (orgId: number) => {
      await apiClient.putOrgId({ id: orgId });
    },
    onSuccess: async () => {
      await handleDefaultMarketplace();
      window.location.href = `${window.location.origin}/user/dashboard`;
    },
    onError: (error) => {
      errorToast({
        message:
          isNetworkError(error) ?
            t(($) => $.common["Something went wrong. Check your connection and try again."])
          : t(($) => $.common["Something went wrong. Please try again."]),
        error,
      });
    },
  });
};
